module.exports = __webpack_public_path__ + "3b5e1e3796cb0a4bf5ab4eb61fe8301f.svg";